import { render, staticRenderFns } from "./PollTable.vue?vue&type=template&id=ef2842fe&"
import script from "./PollTable.vue?vue&type=script&lang=js&"
export * from "./PollTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports